import TopBanner from '../../public/static/banner/main/top-banner.png'
import BottomBanner from '../../public/static/banner/main/bottom-banner.png'
import IconChecked from '../../public/static/banner/main/icon-checked.svg'
import DecorationImg from '../../public/static/banner/main/decoration.svg'
import BottomBannerRight from '../../public/static/banner/main/bottom-banner-right.png'

export function getBannerConfig() {
  return {
    topBanner: {
      img: TopBanner,
      bgColor: '#11182F',
    },
    bottomBanner: {
      img: BottomBanner,
      textColor: '#6BEDFF',
      bgColor: '#0B3861',
      bottomBannerRight: BottomBannerRight,
      title: '',
      titleColor: '#050608',
      iconChecked: IconChecked,
      decoration: DecorationImg,
    },
  }
}
